var $ = require('jquery');

import magnificPopup from "magnific-popup";

$(function(){
  var $popup = $('.js-MagnificPopup');
  if($popup.length) {
    $popup.magnificPopup({
      delegate: 'a',
      type: 'image',
      gallery: {  //ギャラリーオプション
        enabled:true
      },
      zoom: {
        enabled: true,
        duration: 300,
        opener: function(element) {
          return element.find('img');
        }
      }
    });
  }
});

